import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/disputes")({
  component: lazyRouteComponent(() => import("@/pages/admin/Disputes")),
});
